import {
  LayoutDashboard, Package, FolderTree, Image, BadgePercent, Ticket,
  CalendarCheck, FileText, Mail, Users, Settings, Store, Upload, ImageOff, Building2, Boxes, CalendarClock, Send, Tag, UserCog, Landmark, Search, MapPinned, LucideIcon,
} from "lucide-react";
import type { UserRole } from "@/types";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  roles?: UserRole[];
  end?: boolean;
}

export const ADMIN_NAV: NavItem[] = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, roles: ["super_admin", "manager", "staff"], end: true },
  { to: "/admin/reservations", label: "Reservations", icon: CalendarCheck, roles: ["super_admin", "manager", "staff"] },
  { to: "/admin/upcoming-collections", label: "Upcoming Collections", icon: CalendarClock, roles: ["super_admin", "manager", "staff"] },
  { to: "/admin/products", label: "Products", icon: Package, roles: ["super_admin", "manager"] },
  { to: "/admin/inventory", label: "Inventory", icon: Boxes, roles: ["super_admin", "manager", "staff"] },
  { to: "/admin/categories", label: "Categories", icon: FolderTree, roles: ["super_admin", "manager"] },
  { to: "/admin/brands", label: "Brands", icon: Tag, roles: ["super_admin", "manager"] },
  { to: "/admin/media", label: "Media Library", icon: Image, roles: ["super_admin", "manager"] },
  { to: "/admin/promotions", label: "Promotions", icon: BadgePercent, roles: ["super_admin", "manager"] },
  { to: "/admin/hero-banners", label: "Hero Banners", icon: ImageOff, roles: ["super_admin", "manager"] },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket, roles: ["super_admin", "manager"] },
  { to: "/admin/content", label: "Homepage & CMS", icon: FileText, roles: ["super_admin", "manager"] },
  { to: "/admin/areas", label: "Areas We Serve", icon: MapPinned, roles: ["super_admin", "manager"] },
  { to: "/admin/seo", label: "SEO", icon: Search, roles: ["super_admin", "manager"] },
  { to: "/admin/newsletter", label: "Mailing List", icon: Mail, roles: ["super_admin", "manager"] },
  { to: "/admin/marketing", label: "Marketing Emails", icon: Send, roles: ["super_admin", "manager"] },
  { to: "/admin/stores", label: "Stores", icon: Store, roles: ["super_admin"] },
  { to: "/admin/bank-details", label: "Bank Details", icon: Landmark, roles: ["super_admin", "manager"] },
  { to: "/admin/users", label: "Users & Roles", icon: Users, roles: ["super_admin"] },
  { to: "/admin/email-settings", label: "Email Configuration", icon: Mail, roles: ["super_admin"] },
  { to: "/admin/settings", label: "Settings", icon: Settings, roles: ["super_admin"] },
  { to: "/dashboard/profile", label: "My Account", icon: UserCog, roles: ["super_admin", "manager", "staff"] },
];

export const CUSTOMER_NAV: NavItem[] = [
  { to: "/dashboard", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/dashboard/reservations", label: "My Reservations", icon: CalendarCheck },
  { to: "/dashboard/favourites", label: "Favourites", icon: Package },
  { to: "/dashboard/profile", label: "Profile", icon: Settings },
];
